<template>
    <div style="width: 100%;">
        <b-form-file  
            :ref="schema.ref" 
            :accept="schema.accept"
            v-model="value"
            :state="Boolean(value)"
            :placeholder="schema.placeholder"
            :drop-placeholder="schema.dropPlaceholder"
            @change="log(value)"
            :multiple="schema.multiple"
            :file-name-formatter="schema.formatNames"
            :browse-text= "$t('browse')"
            ></b-form-file>
    </div>
</template>
<script>
import { abstractField } from "vue-form-generator";
export default {
    mixins: [ abstractField ],
    methods: {
        log(value){
            console.log(value);
        }
    }
}
</script>